<template>
    <button class="ds-btn" @click="handleExport" :class="{'ds-btn--disabled': isActiveRequest}" :disabled="isActiveRequest">
        Eksportēt
    </button>
</template>
<script>
    import {mapActions, mapGetters, mapMutations} from 'vuex';

    import * as userStoreTypes from '../../vuex/modules/user/user.store-types';
    import * as rootStoreTypes from '../../vuex/root.store-types';
    import * as authStoreTypes from '../../vuex/modules/auth/auth.store-types';

    export default {
        name: 'users-export',
        methods: {
            ...mapMutations({
                /** @type {function|*} */
                setAlertData: rootStoreTypes.SET_ALERT_DATA,
            }),
            ...mapActions('user', {
                /** @type {function|*} */
                exportUsers: userStoreTypes.ACTION_EXPORT_USERS,
            }),
            async handleExport() {
                const csvPath = await this.exportUsers(this.$route.params.companyId || this.currentUser.company._id);

                if (!csvPath) {
                    return this.setAlertData({type: 'danger', message: 'Problēmas ar darbinieku eksporta sagatavošanu!'});
                }

                window.location = csvPath;
                this.setAlertData({type: 'primary', message: 'Darbinieku eksports sagatavots!'});
            },
        },
        computed: {
            ...mapGetters('user', {
                /** @type {boolean|*} */
                isActiveRequest: userStoreTypes.GET_IS_ACTIVE_REQUEST,
            }),
            ...mapGetters('auth', {
                /** @type {CurrentUser|*} */
                currentUser: authStoreTypes.GET_CURRENT_USER,
            }),
        }
    }
</script>